var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative bg-black overflow-hidden",class:_vm.height},_vm._l((_vm.images),function(img,i){return _c('img',{key:i,staticClass:"slide w-full h-full absolute object-fit-pf",class:_vm.slideClasses(i),style:(_vm.styles),attrs:{"src":_vm.imageSrc(img, i),"srcset":_vm.imageSrcset(img, i),"sizes":"100vw","alt":img.alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }